import { render } from "./UpdateNameView.vue?vue&type=template&id=b7e5ca42&ts=true"
import script from "./UpdateNameView.vue?vue&type=script&lang=ts"
export * from "./UpdateNameView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__